module.exports = "<a href=\"javascript:;\" (click)=\"showForm()\">\n    {{scan ? 'Показать' : 'Добавить'}}\n</a>\n"